import { z } from 'zod';

export const IPostCreatePlaidBankAccountResultSchema = z.object({
  status: z.string(),
});

export type IPostCreatePlaidBankAccountResult = z.infer<
  typeof IPostCreatePlaidBankAccountResultSchema
>;

export interface IPostCreatePlaidBankAccountParams {
  currency: string;
  plaid_account_id: string;
  plaid_public_token: string;
}
